import { MuiDropdown, NotificationsPreview } from '@/components';

import { expandDrawer, logout } from '@/store/actions';

import {
  authSelector,
  hasChangesSelector,
  homeSelector,
  intermitenceSelector,
  notificationsSelector,
  storySelector,
} from '@/store/selectors';
import { palette } from '@/theme/constants';
import { logoutWithFacebook } from '@/utils';
import { AppBar, Box, ClickAwayListener, Theme, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'next-i18next';

import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Search from '../Search';
import { getCollaboratorsOptions, getPropmtsOptions } from '../constants';
import NotificationBadge from '../../../../public/icons/components/notificationBadge';
import { CancelModal } from '../CancelModal';
import { UseFirstRender, UseIntermitence } from '@/hooks';
import DrawerComponent from '@/components/DrawerComponent';
import Image from 'next/image';
import AppbarButton from '@/components/AppbarButton';
const MotionAppBar = motion(AppBar);

export const MuiAppBarDesktop: FC<any> = ({ adminPalette, search, setSearch }) => {
  const dispatch = useDispatch();
  const intermitenceData = useSelector(intermitenceSelector);
  const router = useRouter();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [openPeople, setOpenPeople] = useState(false);
  const [showHomeElements, setShowHomeElements] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [showBreadCrumbs, setShowBreadCrumbs] = useState(false);
  const [showSlide, setShowSlide] = useState(false);
  const { status, switchStatus } = UseIntermitence();
  const notifications = useSelector(notificationsSelector);
  const hasChanges = useSelector(hasChangesSelector);
  const { stories } = useSelector(homeSelector);
  const { story } = useSelector(storySelector);
  const { user } = useSelector(authSelector);
  const prompts = getPropmtsOptions(stories, story);
  const collaborators = getCollaboratorsOptions(user?.collaborators || [], story);
  const isMobile = useMediaQuery((template: Theme) => template.breakpoints.down('md'));

  const setShowDropdown = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setIsOpen((isOpen) => !isOpen);
    setOpenNotification(false);
    setOpenFilters(false);
    setOpenPeople(false);
  };

  const setShowFilters = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setOpenFilters((openFilters) => !openFilters);
    setOpenNotification(false);
    setIsOpen(false);
    setOpenPeople(false);
  };

  const setShowPeople = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setOpenPeople((openPeople) => !openPeople);
    setOpenNotification(false);
    setIsOpen(false);
    setOpenFilters(false);
  };

  const handleDrawerChange = () => {
    dispatch(expandDrawer());
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  const handleCloseNotifications = () => {
    setOpenNotification(false);
  };
  const handleCloseFilters = () => {
    setOpenFilters(false);
  };
  const handleClosePeople = () => {
    setOpenPeople(false);
  };

  useEffect(() => {
    if (router.pathname == '/app/home') {
      setShowHomeElements(true);
      setShowBreadCrumbs(false);
      return setShowCancelButton(false);
    }

    if (router?.asPath?.includes('story/create')) {
      setShowCancelButton(true);
      setShowBreadCrumbs(false);
      return setShowHomeElements(false);
    }

    if (router?.pathname == '/app/story/[id]') {
      setShowHomeElements(true);
      return setShowBreadCrumbs(true);
    }

    if (router.pathname == '/app/profile') {
      setShowHomeElements(false);
      setShowBreadCrumbs(true);
      return setShowCancelButton(false);
    }

    if (router.pathname.includes('memory/create') || router.pathname.includes('/update')) {
      setShowCancelButton(true);
      setShowBreadCrumbs(false);
      return setShowHomeElements(false);
    }

    setShowBreadCrumbs(false);
    setShowHomeElements(false);
    setShowCancelButton(false);
  }, [router.pathname]);

  const settingsOptions = [
    {
      label: 'My Profile',
      action: () => router.push('/app/profile'),
    },
    {
      label: 'logout',
      action: async () => {
        dispatch(logout());
        router.push('/app/register');
        await logoutWithFacebook();
      },
    },
  ];

  const handleCloseButton = () => {
    if (hasChanges.hasChanges) {
      switchStatus();
      return;
    }

    if (
      router.pathname?.includes('memory/create') ||
      (router.pathname?.includes('story') && router.pathname?.includes('update') && story?.id)
    ) {
      router.push(`/app/story/${story?.url}`);
    } else {
      router.push('/app/home');
    }
  };

  const closeProcess = () => {
    if (
      router.pathname?.includes('memory/create') ||
      (router.pathname?.includes('story') && router.pathname?.includes('update') && story?.id)
    ) {
      router.push(`/app/story/${story?.url}`);
    } else {
      router.push('/app/home');
    }
  };

  const accentColor = adminPalette.accentColor;
  const storyColor = adminPalette.storyBackgroundColor || 'transparent';

  const buttonStoryBackground = router.pathname === '/app/story/[id]' ? storyColor : palette?.cardBackground;
  const buttonBackground = router.pathname === '/app/story/[id]' ? 'white' : '#0072CE';
  const notificationBackground = router.pathname === '/app/story/[id]' ? accentColor : palette?.primary;
  UseFirstRender(() => {
    const memoryHeight = document.getElementById('memories');
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (router?.pathname == '/app/story/[id]' && (entry.contentRect.height || 0) > 835) {
          setShowSlide(true);
        } else {
          setShowSlide(false);
        }
      }
    });
    if (memoryHeight) resizeObserver.observe(memoryHeight);
    if (router?.pathname == '/app/story/[id]' && (memoryHeight?.clientHeight || 0) > 835) {
      setShowSlide(true);
    } else {
      setShowSlide(false);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [router?.pathname]);
  const isStoryRoute = router.pathname === '/app/story/[id]' || router.pathname === '/app/story/[id]/memory/create';

  const iconSrc = isStoryRoute ? '/icons/notification-white.svg' : '/icons/notification.svg';
  const iconLogo = isStoryRoute ? '/images/logo-new-white.svg' : '/images/logo-new.svg';
  return (
    <>
      <MotionAppBar
        position='fixed'
        elevation={0}
        sx={{
          isolation: 'isolate',
          background: 'transparent',
          width: 'calc(100% - 6px)',
          borderBottom: !router?.pathname.includes('/app/story/') ? '2px solid #0000001A' : '0px transparent',
          left: '0',
          padding: router?.pathname == '/app/story/[id]' && !isMobile ? '0px 64px' : '0px 0px 10px 0px',

          backdropFilter: 'blur(1.5625rem)',
        }}>
        <Box
          width={isMobile ? '100%' : '1200px'}
          maxWidth={'100%'}
          margin={'0 auto'}
          display={'flex'}
          padding={'1rem'}
          justifyContent={'space-between'}
          alignItems={'center'}>
          <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box
              borderRadius={'2.5rem'}
              display={'flex'}
              height={'2.375rem'}
              justifyContent={'space-between'}
              alignItems={'center'}
              gap={'0.625rem'}
              padding={'0.375rem 1rem'}
              bgcolor={palette.cardBackground}
              sx={{ cursor: 'pointer' }}
              onClick={() => router.push('/app/home')}>
              <Image src={iconLogo} alt={'logo'} width={40} height={21} quality={80} />
            </Box>
            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} gap={'0.825rem'}>
              <AppbarButton
                defaultIcon='/icons/memvy-bank.svg'
                link={'/app/home'}
                hoverIcon='/icons/memvy-bank-white.svg'>
                {' '}
                My Memvys
              </AppbarButton>
              <AppbarButton
                defaultIcon='/icons/collab.svg'
                link={'/app/collaborators'}
                hoverIcon='/icons/collab-white.svg'>
                {' '}
                Collaborators
              </AppbarButton>
              <AppbarButton defaultIcon='/icons/profile.svg' link={'/app/profile'} hoverIcon='/icons/profile-white.svg'>
                Profile{' '}
              </AppbarButton>
            </Box>
          </Box>
          <Box position='relative' display='flex' alignItems='center' gap='1rem'>
            {/* Search Input */}
            <Search
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              sx={{ width: '21.5rem' }}
            />

            {/* Notification Icon with Badge */}
            <Box display='flex' alignItems='center' gap='0.5rem'>
              <Image
                src={iconSrc}
                alt='notification'
                width={24}
                height={26}
                style={{ cursor: 'pointer' }}
                onClick={(e: any) => setShowNotification(e)}
              />

              {/* Badge Notification */}
              <NotificationBadge
                color={notificationBackground}
                notifications={notifications?.notifications?.allNotifications?.length || 0}
              />
            </Box>

            {/* Notification Drawer */}
            <DrawerComponent
              open={showNotification}
              onClose={() => setShowNotification(false)}
              listItem={notifications?.notifications?.allNotifications || []}
            />
          </Box>
        </Box>
      </MotionAppBar>

      <ClickAwayListener onClickAway={handleCloseNotifications} disableReactTree={true}>
        <Box position='relative'>
          <NotificationsPreview
            color={buttonBackground}
            isOpen={openNotification}
            handleClose={handleCloseNotifications}
            listItem={notifications?.notifications?.otherNotifications || []}
            type='notification'
            blur={true}
          />
        </Box>
      </ClickAwayListener>

      <ClickAwayListener onClickAway={handleClose} disableReactTree={true}>
        <Box position={'relative'}>
          <MuiDropdown
            hovercolor={buttonBackground}
            color={buttonStoryBackground}
            isOpen={isOpen}
            handleClose={() => handleClose()}
            listItem={settingsOptions}
          />
        </Box>
      </ClickAwayListener>

      <ClickAwayListener onClickAway={handleClosePeople} disableReactTree={true}>
        <Box position='relative'>
          <NotificationsPreview
            color={buttonBackground}
            isOpen={openPeople}
            handleClose={handleClosePeople}
            listItem={notifications?.notifications?.collaborationNotifications || []}
            type={'collaborator'}
            blur={true}
          />
        </Box>
      </ClickAwayListener>

      <ClickAwayListener onClickAway={handleCloseFilters} disableReactTree={true}>
        <Box position={'relative'}></Box>
      </ClickAwayListener>
      <CancelModal open={status} onClose={switchStatus} confirmMethod={closeProcess} />
    </>
  );
};

export default MuiAppBarDesktop;
